"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountItem = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Tooltip = require("../Tooltip");

var AccountSwitcher = function AccountSwitcher(_ref) {
  var showProTip = _ref.showProTip,
      current = _ref.current,
      children = _ref.children,
      onAddNewAccount = _ref.onAddNewAccount,
      onCloseProTip = _ref.onCloseProTip;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = (0, _react.useRef)();
  var active = (0, _react.useMemo)(function () {
    if (!current) {
      return t('retrofit.accounts.switcher.default');
    } else {
      return current;
    }
  }, [current]);

  var handleOnToggle = function handleOnToggle() {
    if (showProTip) {
      onCloseProTip();
    }

    setOpen(!open);
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(RetrofitProTip, {
    open: showProTip,
    onClose: onCloseProTip
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: anchorRef,
    className: "flex items-center h-10 text-light cursor-pointer select-none",
    onClick: handleOnToggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-xs text-left min-w-0 truncate uppercase"
  }, active), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginRight: '-0.3ch'
    }
  }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)))), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    elevation: 6,
    onClose: handleOnToggle,
    anchorEl: anchorRef.current,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-64 text-medium text-sm py-2",
    onClick: handleOnToggle
  }, children, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onAddNewAccount,
    className: "w-full flex items-center justify-between px-4 py-3 text-primary hover:text-primary-active"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1 min-w-0 text-left"
  }, t('retrofit.accounts.switcher.button')), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2 flex"
  }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], {
    fontSize: "small"
  }))))));
};

var _default = AccountSwitcher;
exports["default"] = _default;

var AccountItem = function AccountItem(_ref2) {
  var active = _ref2.active,
      email = _ref2.email,
      unread = _ref2.unread,
      onClick = _ref2.onClick,
      icon = _ref2.icon,
      activeColorCls = _ref2.activeColorCls,
      _ref2$isShowUnreadNum = _ref2.isShowUnreadNumber,
      isShowUnreadNumber = _ref2$isShowUnreadNum === void 0 ? true : _ref2$isShowUnreadNum;
  var unreadNumber = (0, _react.useMemo)(function () {
    if (!unread) {
      return '';
    } else if (unread > 99) {
      return "99+";
    } else {
      return unread.toLocaleString();
    }
  }, [unread]);
  var textColorCls = activeColorCls || 'text-dark';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('w-full flex items-center jutify-between px-4 py-3 hover:bg-secondary cursor-pointer select-none', (0, _defineProperty2["default"])({}, "font-semibold ".concat(textColorCls), active)),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1 min-w-0 text-left truncate"
  }, email), isShowUnreadNumber && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2"
  }, unreadNumber), icon);
};

exports.AccountItem = AccountItem;

var RetrofitProTip = function RetrofitProTip(_ref3) {
  var open = _ref3.open,
      children = _ref3.children,
      onClose = _ref3.onClose;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var handleOnClick = function handleOnClick(e) {
    e.stopPropagation();
    onClose && onClose();
  };

  return /*#__PURE__*/_react["default"].createElement(_Tooltip.ProTip, {
    open: open,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-normal text-left text-sm text-white leading-normal"
    }, t('retrofit.protip')),
    action: /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "font-bold text-xs hover:opacity-75",
      onClick: handleOnClick
    }, t('button.gotIt'))),
    placement: "bottom-end"
  }, children);
};
//# sourceMappingURL=AccountSwitcher.js.map